"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _debug = _interopRequireDefault(require("debug"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var rootKey = 'aa-engine';
var instances = {};

var debugFactory = function debugFactory(instanceKey) {
  var key = "".concat(rootKey, ":").concat(instanceKey);

  if (!instances[key]) {
    instances[key] = (0, _debug["default"])(key);
  }

  return instances[key];
};

var _default = debugFactory;
exports["default"] = _default;